import { useTranslation } from "next-i18next";
import { Span } from "src/components/base";
import { IEntityReference, LikeButton } from "src/components/common/buttons/like-button/like-button";
import { ILikeInfo } from "src/types/common";

interface IFeedCardLikeButtonProps {
    likeInfo: ILikeInfo;
    entityReferences: IEntityReference[];
    onClick?: () => void;
    isCompact?: boolean;
}

export const FeedCardLikeButton = ({ likeInfo, entityReferences, onClick, isCompact }: IFeedCardLikeButtonProps) => {
    const { t } = useTranslation("common");
    return (
        <LikeButton p={isCompact ? [0.5, 1] : 2} iconSpacing={0} size="sm" likeInfo={likeInfo} entityReferences={entityReferences} onClick={onClick}>
            {likeCount => (
                <Span pl={isCompact ? (likeCount > 0 ? [0.5, 1] : 0) : 1}>
                    <Span display={isCompact ? "none" : ["none", "initial", "none", "initial"]}>{t("like")}</Span>
                    {likeCount > 0 && (
                        <Span
                            _before={{ content: isCompact ? "unset" : ["unset", `" ("`, "unset", `" ("`] }}
                            _after={{ content: isCompact ? "unset" : ["unset", `")"`, "unset", `")"`] }}
                        >
                            {likeCount}
                        </Span>
                    )}
                </Span>
            )}
        </LikeButton>
    );
};
